module.exports = __webpack_public_path__ + "img/a12e38fcadb14d0017f7146bbddcf69b.png";